import {useLocation, useNavigate, useSearchParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {GetOrder} from "../../api/order";
import Order from '../../components/object/order'
import Header from "../../components/header";
import Loader from "../../components/loader";

const OrderPage = () => {
    const navigate = useNavigate()
    const [searchParams] = useSearchParams();
    const [orderId] = useState(searchParams.get("orderId"))
    const [back] = useState(searchParams.get("back"))
    const [order, setOrder] = useState(null)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (orderId) {
            setLoading(true)
            GetOrder(orderId).then(setOrder).finally(() => setLoading(false))
        }
    }, [orderId])

    return <div className={"page"} style={{height:"100vh", overflow:"auto"}}>
        <Loader
            visible={loading}
        />
        <Header title={"Оплата"} onBack={() => {
            navigate("/objects/" + order.object_id +"?no_back=true")
        }}/>
        {order && <Order order={order}/>}
    </div>
}

export default OrderPage